// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { Separator } from 'client/components/separator';
import { colors, columns, units } from 'client/styles';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';

/**
 * `Props` type.
 */

type Props = {
  icon: string,
  text: string,
  title: string
};

/**
 * Styles.
 */

const styles = {
  icon: `
    left: ${columns(2)}%;
    position: relative;
  `,
  separator: `
    background-color: ${colors.white};
  `
};

/**
 * `Workflow` component.
 */

const Workflow = ({ icon, text, title }: Props): React$Element<*> => (
  <Row>
    <Layout
      alignItemsSM={'center'}
      displaySM={'flex'}
    >
      <Layout
        display={'none'}
        displaySm={'block'}
      >
        <Col
          lg={5}
          sm={4}
          smOffset={0}
          xs={10}
          xsOffset={1}
        >
          <Layout
            paddingTopLg={0}
            paddingTopSm={units(18)}
          >
            <Icon
              icon={icon}
              size={'100%'}
              styles={styles.icon}
            />
          </Layout>
        </Col>
      </Layout>

      <Col
        sm={5}
        smOffset={1}
        xs={10}
        xsOffset={1}
      >
        <Layout
          paddingVertical={units(8)}
          paddingVerticalSm={units(10)}
        >
          <Layout
            marginBottom={units(4)}
            marginBottomMd={units(6)}
            maxWidth={units(60)}
          >
            <Text.H2
              color={colors.white}
              marginBottom={0}
            >
              {title}
            </Text.H2>
          </Layout>

          <Row>
            <Col xs={2}>
              <Layout
                display={'none'}
                displayMd={'block'}
              >
                <Separator.Horizontal
                  styles={styles.separator}
                  topRight
                />
              </Layout>
            </Col>

            <Col
              md={10}
              mdOffset={2}
              xs={12}
            >
              <Text.Paragraph color={colors.white}>
                <RawHtml.span>
                  {text}
                </RawHtml.span>
              </Text.Paragraph>

              <Layout
                display={'block'}
                displaySm={'none'}
                paddingTop={units(4)}
              >
                <Icon
                  icon={icon}
                  size={'100%'}
                />
              </Layout>
            </Col>
          </Row>
        </Layout>
      </Col>
    </Layout>
  </Row>
);

/**
 * Export `Workflow` component.
 */

export default Workflow;



// WEBPACK FOOTER //
// ../src/client/components/for-agents/workflow.js